import { IBundleProduct } from "../../entities/manhattan/bundle/types";
import BundleProductService from "../../services/BundleProductService";

export default class BundleProductBusinessRuleFacade {

  private static instance: BundleProductBusinessRuleFacade;
  private readonly bundleProductService: BundleProductService;
  private bundleProduct: IBundleProduct;

  private constructor() {
    this.bundleProductService = BundleProductService.getInstance();
  }

  public static getInstance(): BundleProductBusinessRuleFacade {
    if (!this.instance) {
      this.instance = new BundleProductBusinessRuleFacade();
    }

    return this.instance;
  }

  public init(bundleProduct: IBundleProduct) {
    this.bundleProduct = bundleProduct;
    this.bundleProductService.init(this.bundleProduct);
  }

  public isAllowedMinimumDevices() {
    return this.bundleProductService.getBundleProductMinimumDevices() > 0;
  }

  public isAllowedMaximumDevices() {
    return this.bundleProductService.getBundleProductMaximumDevices() > 0;
  }

  public isAllowedAdditionalDevices() {
    return this.bundleProductService.getBundleProductNumberOfAdditionalDevices() > 0;
  }


}
